import React from "react";
import { renderBrandText } from "../utils/brandText";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-container" translate="no">
            <h1>Política de Privacidad</h1>
            <h3>
                Última actualización: 5 de marzo de 2025
            </h3>
            <p>
                {renderBrandText("Bienvenido a TheQAHub. Nos tomamos muy en serio la privacidad de nuestros usuarios y nos comprometemos a proteger sus datos personales. En esta Política de Privacidad, explicamos cómo recopilamos, usamos y protegemos su información.")}
            </p>
            <h3>1. Información que recopilamos</h3>
            <p>
                Recopilamos la siguiente información cuando utiliza nuestros servicios:
            </p>
            <ul>
                <li>Datos personales: Nombre, dirección de correo electrónico y cualquier otra información que proporcione voluntariamente al registrarse o suscribirse a nuestro contenido.</li>
                <li>Datos de navegación: Dirección IP, tipo de navegador, páginas visitadas y tiempo de permanencia en nuestro sitio web.</li>
                <li>Cookies y tecnologías similares: Para mejorar la experiencia del usuario y analizar el tráfico del sitio web.</li>
            </ul>
            <h3>2. Uso de la información</h3>
            <p>
                Usamos su información para:
            </p>
            <ul>
                <li>Proporcionarle contenido relevante sobre QA y desarrollo de software.</li>
                <li>Mejorar nuestros servicios y personalizar su experiencia en nuestra plataforma.</li>
                <li>Enviar actualizaciones, newsletters o información promocional (siempre con su consentimiento).</li>
                <li>Cumplir con nuestras obligaciones legales y de seguridad.</li>
            </ul>
            <h3>3. Compartición de información</h3>
            <p>
                No compartimos su información personal con terceros, excepto en los siguientes casos:
            </p>
            <ul>
                <li>Cuando sea necesario para prestar un servicio que haya solicitado.</li>
                <li>Si es requerido por la ley o una autoridad competente.</li>
                <li>Para proteger nuestros derechos legales o la seguridad de nuestros usuarios.</li>
            </ul>
            <h3>4. Derechos del usuario</h3>
            <p>
                Usted tiene derecho a:
            </p>
            <ul>
                <li>Acceder, rectificar o eliminar sus datos personales.</li>
                <li>Retirar su consentimiento para el uso de sus datos en cualquier momento.</li>
                <li>Presentar una queja ante la autoridad de protección de datos si considera que sus derechos han sido vulnerados.</li>
            </ul>
            <h3>5. Seguridad de la información</h3>
            <p>
                Adoptamos medidas técnicas y organizativas para proteger sus datos contra accesos no autorizados, alteraciones o pérdidas.
            </p>
            <h3>6. Cambios en la Política de Privacidad</h3>
            <p>
                Adoptamos medidas técnicas y organizativas para proteger sus datos contra accesos no autorizados, alteraciones o pérdidas.
            </p>
            <h3>Contacto</h3>
            <p>
            Si tiene preguntas sobre esta Política de Privacidad, puede contactarnos a través de <a href="mailto:diego.sanchez@theqahub.com"><strong>diego.sanchez@theqahub.com</strong></a>.
            </p>
        </div>
    );
};

export default PrivacyPolicy;
